import { createSelector } from '@reduxjs/toolkit';

import { PRODUCT_TYPES_VALUES } from 'constants/dictionaries';

import type { SliceStateFromReducer } from '../../../shared/types';

import type { offersFiltersSlice } from './offersFilters.slice';

export type TOffersFiltersState = SliceStateFromReducer<typeof offersFiltersSlice>;

export const offersFiltersSelector = (state: TOffersFiltersState) => state.offersFilters.form;
export const offersFiltersDictionariesSelector = (state: TOffersFiltersState) => state.offersFilters.dictionaries;

export const productTypeSelector = createSelector(offersFiltersSelector, (filters) => {
  const productTypes = filters?.productTypes || [];

  return productTypes?.find((type) => type === 'Credit') || productTypes?.[0];
});

export const isCreditCardProductTypeSelector = createSelector(
  productTypeSelector,
  (productType) => productType === PRODUCT_TYPES_VALUES.CREDIT_CARD,
);
